import React, { useRef, useState } from "react";

// reactstrap components
import {
    Card,
    CardHeader,
    CardBody,
    NavItem,
    NavLink,
    Nav,
    Collapse,
    Button,
} from "reactstrap";

import useHelpKey from '../../hooks/useHelpKey';

const LegalContent = () => {
    // collapse states and functions
    const [collapses, setCollapses] = useState(false);
    const terms1 = useHelpKey("/common", 501, "de");
    const terms2 = useHelpKey("/common", 502, "de");
    const terms3 = useHelpKey("/common", 503, "de");
    const terms4 = useHelpKey("/common", 504, "de");

    const accordionHash = useRef(null);

    const changeCollapse = collapse => {
        collapses !== collapse ? setCollapses(collapse) : setCollapses(false);
    };

    const handleScroll = (ref) => {
        if (ref !== "<p />") {
            window.scrollTo({
                top: ref.getBoundingClientRect().top - 75,
                left: 0,
                behavior: "smooth",
            });
        }
    };

    const onEntered = () => handleScroll(accordionHash.current)
    const onExited = () => {
        if (collapses === false) {
            window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
        }
    }
    return (
        <>
            <Card className="card-nav-tabs card-plain" aria-multiselectable={true}>
                <CardHeader className="card-header-warning"  >

                    <Nav className="justify-content-center">
                        <p className="py-2 px-3 mr-5 m-0" ref={accordionHash}>Alpha Research Deutschland GmbH</p>
                        <div className="row md-row-12 justify-content-center">
                            <NavItem>
                                <NavLink
                                    data-toggle="collapse"
                                    className={collapses === 1 ? "active text-info" : "text-dark"}
                                    href="#privacy"
                                    onClick={e => {
                                        e.preventDefault();
                                        changeCollapse(1);
                                    }}
                                >
                                    Datenschutz
                                </NavLink>
                            </NavItem>
                            <p className="py-2 px-3 m-0">|</p>
                            <NavItem>
                                <NavLink
                                    data-toggle="collapse"
                                    className={collapses === 2 ? "active text-info" : "text-dark"}
                                    href="#myData"
                                    onClick={e => {
                                        e.preventDefault();
                                        changeCollapse(2);

                                    }}
                                >
                                    Meine Daten
                                </NavLink>
                            </NavItem>
                            <p className="py-2 px-3 m-0 d-none d-sm-block">|</p>
                            <p className="py-2 px-3 m-0 d-md-none"> </p>
                            <NavItem>
                                <NavLink
                                    data-toggle="collapse"
                                    className={collapses === 3 ? "active text-info" : "text-dark"}
                                    href="#terms"
                                    onClick={e => {
                                        e.preventDefault();
                                        changeCollapse(3);

                                    }}
                                >
                                    AGB's
                                </NavLink>
                            </NavItem>
                            <p className="py-2 px-3 m-0">|</p>
                            <NavItem>
                                <NavLink
                                    data-toggle="collapse"
                                    className={collapses === 4 ? "active text-info" : "text-dark"}
                                    href="#imprint"
                                    onClick={e => {
                                        e.preventDefault();
                                        changeCollapse(4);

                                    }}
                                >
                                    Impressum
                                </NavLink>
                            </NavItem>
                        </div>
                    </Nav>
                </CardHeader>
                <CardBody>

                    <Collapse isOpen={collapses === 1}
                        onEntered={onEntered}
                        onExited={onExited}
                    >
                        <div dangerouslySetInnerHTML={{__html: terms1.text}}/>

                        <Button
                            type="button"
                            color="info"
                            size="sm"
                            className="mb-3 btn-block"
                            onClick={() => changeCollapse(false)}
                        >
                            schließen
                        </Button>
                    </Collapse>

                    <Collapse isOpen={collapses === 2}
                        onEntered={onEntered}
                        onExited={onExited}
                    >
                        <div dangerouslySetInnerHTML={{__html: terms2.text}}/>
                        <Button
                            type="button"
                            color="info"
                            size="sm"
                            className="mb-3 btn-block"
                            onClick={() => changeCollapse(false)}
                        >
                            schließen
                        </Button>
                    </Collapse>
                    <Collapse isOpen={collapses === 3}
                        onEntered={onEntered}
                        onExited={onExited}
                    >
                        {/*<TermsCardContent />*/}
                        <div dangerouslySetInnerHTML={{__html: terms3.text}}/>
                        <Button
                            type="button"
                            color="info"
                            size="sm"
                            className="mb-3 btn-block"
                            onClick={() => changeCollapse(false)}
                        >
                            schließen
                        </Button>
                    </Collapse>
                    <Collapse isOpen={collapses === 4}
                        onEntered={onEntered}
                        onExited={onExited}
                    >
                        <div dangerouslySetInnerHTML={{__html: terms4.text}}/>
                        <Button
                            type="button"
                            color="info"
                            size="sm"
                            className="mb-3 btn-block"
                            onClick={() => changeCollapse(false)}
                        >
                            schließen
                        </Button>
                    </Collapse>
                </CardBody>
            </Card >
        </>
    );
}

export default LegalContent;